import { COLORS } from '@btime/constants'
import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { useTranslation } from 'react-i18next'
import { useModalData } from '../../../components/modals/ModalsContext'

const ModalHeader = () => {
  const data = useModalData()
  const { t } = useTranslation('placeTypes')

  const title = data && data.key ? `${t('edit.title')} ${t('placeType')}` : `${t('create.title')} ${t('placeType')}`
  return (
    <>
      <Title size="h4" color={COLORS.dark2} noMargin>
        {title}
      </Title>
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
